// extracted by mini-css-extract-plugin
module.exports = {"pill_list":"styles_pill_list__HW_b9","pill_list_item":"styles_pill_list_item__XbsvU","pill_list_item_link":"styles_pill_list_item_link__Y97hc"};